import React, { useEffect, useState } from 'react'
import InputMask from 'react-input-mask'
import { useForm, Controller } from 'react-hook-form'
import { makeStyles } from '@material-ui/core/styles'

import { TextField, Grid, Button, Divider } from '@material-ui/core'
import API from '../../../services/api'

import Modal from '../../../components/atoms/Modal'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
    maxWidth: 760,
  },
  nomeDaLoja: {
    margin: 0,
    fontSize: 20,
    fontWeight: 600,
    color: '#d05d02',
  },
  secao: {
    margin: '4px 0 0',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.6px',
    color: '#7A7373',
  },
  divisor: {
    marginBottom: theme.spacing(1.5),
  },
  salvar: {
    background: '#d05d02',
    color: '#fff',
    fontSize: '14px',
    textTransform: 'capitalize',
    fontWeight: 700,
    width: '138px',
    '&:hover': { background: '#A74A00' },
  },
}))

/** 39466639000100 -> 39.466.639/0001-00 */
function formatarCnpj(valor) {
  const digitos = String(valor || '').replace(/\D/g, '')
  if (digitos.length !== 14) return valor || ''
  return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

function Dados() {
  const classes = useStyles()
  const [store, setStore] = useState(false)
  const [openModal, setOpenModal] = useState(null)

  const { register, control, handleSubmit } = useForm()

  const closeModal = () => {
    setOpenModal(false)
  }

  useEffect(() => {
    const getStore = async () => {
      const result = await API.get('store')
      setStore(result.data)
    }
    if (!store) {
      getStore()
    }
  }, [])

  const onSubmit = async (data) => {
    const {
      uf,
      cidade,
      cep,
      logradouro,
      numero,
      complemento,
      bairro,
      tel,
      whatsapp,
    } = data

    const updateData = {
      ...store,
      location: {
        uf,
        city: cidade,
        postalCode: cep,
        street: logradouro,
        number: numero,
        complement: complemento,
        neighborhood: bairro,
      },
      contact: {
        phoneNumber: tel,
        whatsapp,
      },
    }

    try {
      const result = await API.post('store', updateData)
      setOpenModal(result.data.message)
    } catch (err) {
      console.log(err)
    }
  }

  if (!store) {
    return null
  }
  return (
    <>
      <Modal
        open={openModal && true}
        close={closeModal}
        titleDescription={openModal}
        verification={false}
      />
      <form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h2 className={classes.nomeDaLoja}>{store.name}</h2>
          </Grid>

          <Grid item xs={12} sm={7} md={7}>
            <TextField
              fullWidth
              id="CNPJ"
              name="cnpj"
              inputRef={register}
              label="CNPJ"
              variant="outlined"
              size="small"
              placeholder=""
              defaultValue={formatarCnpj(store.cnpj)}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5} md={5}>
            <Controller
              control={control}
              defaultValue={store.location.postalCode}
              name="cep"
              as={
                <InputMask mask="99999-999">
                  {() => (
                    <TextField
                      fullWidth
                      id="cep"
                      name="cep"
                      inputRef={register}
                      label="CEP"
                      variant="outlined"
                      size="small"
                      placeholder=""
                    />
                  )}
                </InputMask>
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Divider variant="fullWidth" className={classes.divisor} />
            <h3 className={classes.secao}>ENDEREÇO</h3>
          </Grid>
          <Grid item xs={12} sm={8} md={6}>
            <TextField
              fullWidth
              id="logradouro"
              name="logradouro"
              inputRef={register}
              label="RUA"
              variant="outlined"
              size="small"
              placeholder=""
              defaultValue={store.location.street}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2}>
            <TextField
              fullWidth
              id="numero"
              name="numero"
              inputRef={register}
              label="NÚMERO"
              variant="outlined"
              size="small"
              placeholder=""
              defaultValue={store.location.number}
            />
          </Grid>
          <Grid item xs={8} sm={12} md={4}>
            <TextField
              fullWidth
              id="complemento"
              name="complemento"
              inputRef={register}
              label="COMPLEMENTO"
              variant="outlined"
              size="small"
              placeholder=""
              defaultValue={store.location.complement}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={5}>
            <TextField
              fullWidth
              id="bairro"
              name="bairro"
              inputRef={register}
              label="BAIRRO"
              variant="outlined"
              size="small"
              placeholder=""
              defaultValue={store.location.neighborhood}
            />
          </Grid>
          <Grid item xs={8} sm={4} md={5}>
            <TextField
              fullWidth
              id="cidade"
              name="cidade"
              inputRef={register}
              label="CIDADE"
              variant="outlined"
              size="small"
              placeholder=""
              defaultValue={store.location.city}
            />
          </Grid>
          <Grid item xs={4} sm={2} md={2}>
            <TextField
              fullWidth
              id="uf"
              name="uf"
              inputRef={register}
              label="UF"
              variant="outlined"
              size="small"
              placeholder=""
              defaultValue={store.location.uf}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider variant="fullWidth" className={classes.divisor} />
            <h3 className={classes.secao}>CONTATO</h3>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Controller
              control={control}
              defaultValue={store.contact.phoneNumber}
              name="tel"
              as={
                <InputMask mask="(99) 9999-9999">
                  {() => (
                    <TextField
                      fullWidth
                      id="tel"
                      name="tel"
                      inputRef={register}
                      label="TELEFONE"
                      variant="outlined"
                      size="small"
                      placeholder=""
                    />
                  )}
                </InputMask>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Controller
              control={control}
              defaultValue={store.contact.whatsapp}
              name="whatsapp"
              as={
                <InputMask mask="(99) 99999-9999">
                  {(inputProps) => (
                    <TextField
                      fullWidth
                      name="whatsapp"
                      label="WHATSAPP"
                      variant="outlined"
                      size="small"
                      {...inputProps}
                    />
                  )}
                </InputMask>
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Divider variant="fullWidth" className={classes.divisor} />
          </Grid>

          <Grid item xs={12} container justify="flex-end">
            <Button
              variant="contained"
              type="submit"
              className={classes.salvar}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default Dados
